<template>
    <!-- Footer
============================================= -->
    <footer id="footer" class="dark">

        <!-- Copyrights
        ============================================= -->
        <div id="copyrights">

            <div class="container clearfix">

                <div class="col_one_third">
                    v{{appVersion}} Copyright &copy; 2020 All Rights Reserved<br>
                    <div class="copyright-links"><a href="http://www.tdadental.com/terms">Terms of Use</a> / <a href="http://www.tdadental.com/privacy">Privacy Policy</a></div>
                </div>
                <div class="fright clearfix">
                    <a href="https://www.facebook.com/TDAdental" class="social-icon si-small si-borderless nobottommargin si-facebook">
                        <i class="icon-facebook"/>
                        <i class="icon-facebook"/>
                    </a>
                    <a href="https://twitter.com/TDAdental" class="social-icon si-small si-borderless nobottommargin si-twitter">
                        <i class="icon-twitter"/>
                        <i class="icon-twitter"/>
                    </a>
                    <a href="https://www.linkedin.com/company/total-dental-administrators" class="social-icon si-small si-borderless nobottommargin si-linkedin">
                        <i class="icon-linkedin"/>
                        <i class="icon-linkedin"/>
                    </a>
                </div>

            </div>

        </div><!-- #copyrights end -->

    </footer><!-- #footer end -->
</template>

<script>
    import config from '@/config/config.js'
    export default {
        name: 'MainFooter',
        data() {
            return {
                appVersion: config.applicationSettings.version
            }
        }
    }
</script>

<style scoped>

</style>
